const success = (request) => {
	const accessToken = localStorage.getItem('access_token');

	if (accessToken) {
		request.headers.Authorization = `Bearer ${accessToken}`;
	}

	return request;
};

const error = (err) => Promise.reject(err);

export default {
	success,
	error,
};